import React, { useContext, useEffect, useState } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { ArrowNarrowRightIcon, HandIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import { useLocation } from "react-router-dom"

export const ListHubContacts = ({ hubId, onContactSelect }) => {
	const [contactList, setContactList] = useState([])
	const [loading, setLoading] = useState(false)
	const [searchText, setSearchText] = useState("")
	const location = useLocation()

	const getContacts = (query) => {
		if (query.length < 3) {
			toast("Please enter at least 3 characters")
			return
		}
		setLoading(true)
		;(async () => {
			const res = await axiosInstance.get(EndpointConfig.hubAppContacts, {
				params: { query },
				headers: { "hub-id": hubId }
			})
			setContactList(res.data.results)
			setSearchText("")
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const getAllContacts = (hubId) => {
		return axiosInstance.get(EndpointConfig.hubAppAllContacts, {
			headers: { "hub-id": hubId }
		})
	}

	const handleContactSelect = (contact) => {
		const contactProperties = contact.properties

		if (contactProperties?.phone) {
			onContactSelect([{ ...contactProperties }])
		}
	}

	const selectAllContacts = async () => {
		const { data } = await getAllContacts(hubId)

		const contactProperties = data
			.filter((contact) => contact?.properties?.phone)
			.map((contact) => contact.properties)

		onContactSelect(contactProperties)
	}

	React.useEffect(() => {
		const urlSearchParam = new URLSearchParams(location.search)
		const hubspotDetails = {}
		for (const [key, value] of urlSearchParam) {
			hubspotDetails[key] = value
		}
		if (hubspotDetails.firstname) {
			getContacts(hubspotDetails.firstname)
		}
	}, [])

	return (
		<div className="flex flex-col">
			{loading ? (
				<div className="text-xs font-bold text-blue-800 uppercase">loading...</div>
			) : null}
			{!loading ? (
				<>
					<div className="flex flex-col items-center justify-center gap-1">
						<Input
							onChange={(e) => setSearchText(e.target.value)}
							value={searchText}
							placeholder="Search email, phone, name"
						/>
						<Button className={"w-full"} onClick={() => getContacts(searchText)}>
							Search
						</Button>
						<Button className={"w-full"} onClick={() => selectAllContacts()}>
							Select All Contact
						</Button>
					</div>
				</>
			) : null}
			<div className="pr-4 overflow-y-auto h-60">
				{contactList.map((usr, i) => {
					return (
						<div key={i} className="flex flex-row items-center">
							<div className="flex flex-col flex-1 py-2 border-t border-gray-100 border-solid">
								<div className="flex-1 text-xs tracking-wide text-gray-800 uppercase">
									{usr?.properties?.firstname} {usr?.properties?.lastname}
								</div>
								<div className="">{usr?.properties?.phone}</div>
							</div>
							<div>
								<ArrowNarrowRightIcon
									className="w-8 h-8 text-blue-500 cursor-pointer"
									onClick={() => handleContactSelect(usr)}
								/>
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}
